import { RosaAuthService } from '@/rosa';
import { inject } from '@angular/core';
import { type CanActivateChildFn, type CanActivateFn, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { SESSION_STORAGE_KEYS } from '../../providers/local-storage.contants';

export const generalConditionsAcceptedGuard: CanActivateFn & CanActivateChildFn = async () => {
    const rosaAuthService = inject(RosaAuthService);
    const router = inject(Router);

    const areGeneralConditionAccepted = await firstValueFrom(rosaAuthService.areGeneralConditionAccepted$());
    const isPrintingReport = sessionStorage.getItem(SESSION_STORAGE_KEYS.REPORT_PRINT_SESSION) === 'true';

    if (!isPrintingReport && !areGeneralConditionAccepted) {
        router.navigate(['/', 'general-conditions']);
        return false;
    }

    return true;
};
